/**
 * @module Print
 */

export enum ActionType {
  APP = 'APP::PRINT::APP',
}

export enum Action {
  APP = 'APP',
}



// WEBPACK FOOTER //
// ./src/actions/Print/types.ts